import React from "react";
import PropTypes from "prop-types";

// TODO: Change class names when PDP is React #bem
// Move to webpack compile

class PDPAdminDetail extends React.Component {
  static propTypes = {
    product: PropTypes.shape({
      id: PropTypes.string,
      published: PropTypes.bool,
    }),
  };

  render() {
    var product = this.props.product;
    return (
      <div className="pdp-ci-detail">
        <p className="universal-small--semibold">{product.id}</p>
        <p className={product.published ? "universal-small" : "universal-small--semibold"}>
          {product.published ? "Published" : "Unpublished"}
        </p>
        <p>
          <a
            className="universal-small universal-underline"
            href={"/pdp/admin_redirect/" + product.id}
            rel="noopener noreferrer"
            target="_blank">
            Edit Item
          </a>
        </p>
        <p>
          <a
            href={"/pdp/admin_availability/" + product.id}
            className="universal-small universal-underline"
            rel="noopener noreferrer"
            target="_blank">
            Show availability
          </a>
        </p>
      </div>
    );
  }
}

export default PDPAdminDetail;
